import React from 'react';

import { useEntitlements } from '../../services/entitlementsService';

// Badge colors per tier for the Order Dashboard plan badge.
const TIER_BADGE = {
  free: { label: 'Free Tier', color: '#6c757d' },
  founding: { label: 'Founding', color: '#20a39e' },
  pro: { label: 'Pro Tier', color: '#F15A29' },
  enterprise: { label: 'Enterprise', color: '#6f42c1' }
};

// Order Dashboard badge: shows the customer's current plan (no price, no action).
const CustomerPlanBanner = () => {
  const ent = useEntitlements();

  if (!ent) return null;

  const tier = ent.tier || 'free';
  const meta = TIER_BADGE[tier] || { label: tier, color: '#6c757d' };

  return (
    <div style={{ margin: '0 0 14px' }}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: meta.color,
          color: '#fff',
          borderRadius: 999,
          padding: '5px 14px',
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: '0.02em'
        }}
      >
        {meta.label}
      </span>
    </div>
  );
};

export default CustomerPlanBanner;
